import React, { useEffect, useState } from 'react';
import { User, Document, DocumentType } from '../types';
import { api } from '../services/api';
import { Loader2 } from 'lucide-react';
import { ClientObligationsCalendar } from './ClientObligationsCalendar';

interface ClientObligationsViewProps {
    user: User;
}

export const ClientObligationsView: React.FC<ClientObligationsViewProps> = ({ user }) => {
    const [documents, setDocuments] = useState<Document[]>([]);
    const [documentTypes, setDocumentTypes] = useState<DocumentType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchDocs = async () => {
            if (user.agencyId) {
                try {
                    const [docs, types] = await Promise.all([
                        api.getDocuments(user.agencyId, user.id),
                        api.getDocumentTypes(user.agencyId, true)
                    ]);
                    setDocuments(docs);
                    setDocumentTypes(types);
                } catch (error) {
                    console.error("Failed to fetch documents for calendar", error);
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        };
        fetchDocs();
    }, [user.id, user.agencyId]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <Loader2 className="animate-spin text-slate-400" size={32} />
            </div>
        );
    }

    return (
        <ClientObligationsCalendar documents={documents} documentTypes={documentTypes} />
    );
};
